import { vars } from '@etg/wings';
import { css } from '@eti/styles';
import variants from '../../utils/variants';
const notificationVariants = {
  [variants.INFORMATION]: css`
    background-color: ${vars.colors.signal.information.background};
    border: 1px solid ${vars.colors.signal.information.foreground};
  `,
  [variants.CONFIRMATION]: css`
    background-color: ${vars.colors.signal.positive.background};
    border: 1px solid ${vars.colors.signal.positive.foreground};
  `,
  [variants.WARNING]: css`
    background: ${vars.colors.signal.caution.background};
    border: 1px solid ${vars.colors.signal.caution.foreground};
  `,
  [variants.CRITICAL]: css`
    background: ${vars.colors.signal.critical.background};
    border: 1px solid ${vars.colors.signal.critical.foreground};
  `
};
export const variantStyles = function (variant) {
  if (variant === void 0) {
    variant = 'info';
  }
  return notificationVariants[variant];
};
//# sourceMappingURL=notificationStyles.js.map